import NiceModal from "@ebay/nice-modal-react";
import ModalBase from "modals/base/ModalBase";
import { useRef } from "react";
import { useTranslation } from "react-i18next";
import VerticalFlex from "layouts/flex/VerticalFlex";
import FlexChild from "layouts/flex/FlexChild";
import Center from "layouts/wrapper/Center";
import P from "components/P";
import CustomButton from "components/buttons/CustomButton";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { fas } from "@fortawesome/free-solid-svg-icons";
import style from "./AppUpdateModal.module.css";
import { devLog } from "utils/logger";
const AppUpdateModal = NiceModal.create(({ 
    currentVersion, 
    latestVersion, 
    appVersion, // 기존 호환성 유지
    storeType = 'one', 
    marketType, // 새로운 prop
    isForced = true,
    onUpdateClick // 새로운 prop
}) => {
    const { t } = useTranslation();
    const modal = useRef();
    const [withHeader, withFooter] = [false, false];
    const [width, height] = ["90%", "auto"];
    const withCloseButton = !isForced;
    const clickOutsideToClose = !isForced;
    const title = "";
    const buttonText = t("close");

    // 새로운 형식과 기존 형식 모두 지원
    const finalStoreType = marketType || storeType;
    const finalLatestVersion = latestVersion || appVersion;

    const handleUpdate = () => {
        try {
            devLog('🚀 [AppUpdateModal] 업데이트 버튼 클릭');
            
            // 새로운 onUpdateClick 콜백이 있으면 사용
            if (onUpdateClick && typeof onUpdateClick === 'function') {
                onUpdateClick();
                return;
            }

            // 기존 로직 (호환성 유지)
            const storeUrls = {
                one: 'https://onestoremarket.co.kr/ko/apps/appsDetail.omp?prodId=0000773778',
                onestore: 'https://onestoremarket.co.kr/ko/apps/appsDetail.omp?prodId=0000773778',
                galaxy: 'https://galaxystore.samsung.com/detail/com.vending.puffu',
                samsung: 'https://galaxystore.samsung.com/detail/com.vending.puffu',
                google: 'https://play.google.com/store/apps/details?id=com.vending.puffu',
                playstore: 'https://play.google.com/store/apps/details?id=com.vending.puffu',
                debug: 'https://onestoremarket.co.kr/ko/apps/appsDetail.omp?prodId=0000773778'
            };

            const targetUrl = storeUrls[finalStoreType] || storeUrls.google;

            if (window.BRIDGE && window.BRIDGE.openMarketForUpdate) {
                window.BRIDGE.openMarketForUpdate(finalStoreType);
            } else if (window.BRIDGE && window.BRIDGE.openStore) {
                window.BRIDGE.openStore(targetUrl);
            } else {
                window.open(targetUrl, '_blank');
            }

            if (isForced) {
                setTimeout(() => {
                    if (window.BRIDGE && window.BRIDGE.closeApp) {
                        window.BRIDGE.closeApp();
                    }
                }, 1000);
            } else {
                modal.current.close();
            }
        } catch (error) {
            console.error('앱 업데이트 처리 오류:', error);
        }
    };

    const handleLater = () => {
        if (!isForced && modal.current) {
            modal.current.close();
        }
    };

    const getStoreDisplayName = () => {
        switch (finalStoreType) {
            case 'one':
            case 'onestore': 
                return '원스토어';
            case 'galaxy':
            case 'samsung': 
                return '갤럭시 스토어';
            case 'google':
            case 'playstore': 
                return '구글 플레이';
            case 'debug':
                return '테스트 스토어';
            default: 
                return '앱스토어';
        }
    };

    const getStoreIcon = () => {
        switch (finalStoreType) {
            case 'one':
            case 'onestore': 
                return fas.faStore;
            case 'galaxy':
            case 'samsung': 
                return fas.faMobile;
            case 'google':
            case 'playstore': 
                return fas.faGooglePlay;
            case 'debug':
                return fas.faBug;
            default: 
                return fas.faStore;
        }
    };

    return (
        <ModalBase
            ref={modal}
            width={width}
            height={height}
            withHeader={withHeader}
            withFooter={withFooter}
            withCloseButton={withCloseButton}
            clickOutsideToClose={clickOutsideToClose}
            title={title}
            buttonText={buttonText}
            borderRadius={"24px"}
        >
            <div className={style.container}>
                {/* 메인 아이콘과 배경 */}
                <div className={style.heroSection}>
                    <div className={style.iconBackground}>
                        <FontAwesomeIcon 
                            icon={fas.faRocket} 
                            className={style.mainIcon}
                        />
                    </div>
                    <div className={style.sparkles}>
                        <div className={style.sparkle}></div>
                        <div className={style.sparkle}></div>
                        <div className={style.sparkle}></div>
                    </div>
                </div>

                {/* 타이틀 */}
                <div className={style.titleSection}>
                    <h2 className={style.title}>새로운 버전이 출시되었어요! 🎉</h2>
                    <p className={style.subtitle}>
                        더 빠르고 안정적인 서비스를 만나보세요
                    </p>
                </div>

                {/* 버전 정보 */}
                {/* <div className={style.versionSection}>
                    <div className={style.versionCard}>
                        <div className={style.versionRow}>
                            <div className={style.versionItem}>
                                <span className={style.versionLabel}>현재</span>
                                <span className={style.currentVersion}>{currentVersion || '1.0.0'}</span>
                            </div>
                            <div className={style.arrow} style={{width: "max-content"}}>
                                <FontAwesomeIcon icon={fas.faArrowRight} />
                            </div>
                            <div className={style.versionItem}>
                                <span className={style.versionLabel}>최신</span>
                                <span className={style.latestVersion}>{finalLatestVersion}</span>
                            </div>
                        </div>
                    </div>
                </div> */}

                {/* 스토어 정보 */}
                {/* <div className={style.storeSection}>
                    <div className={style.storeCard}>
                        <FontAwesomeIcon 
                            icon={getStoreIcon()} 
                            className={style.storeIcon} 
                        />
                        <span className={style.storeName}>{getStoreDisplayName()}</span>
                    </div>
                </div> */}

                {/* 버튼 그룹 */}
                <div className={style.buttonSection}>
                    <button 
                        className={style.updateButton}
                        onClick={handleUpdate}
                    >
                        <FontAwesomeIcon icon={fas.faDownload} className={style.buttonIcon} />
                        <span>지금 업데이트</span>
                    </button>
                </div>
            </div>
        </ModalBase>
    );
});

export default AppUpdateModal; 